import React from 'react';
import styled from 'styled-components';
import { Grid, Typography } from '@material-ui/core';
import { textBold, colors } from 'styles';
import { breakpoint } from 'src/utils/mediaQueries';
import { FormattedMessage } from 'react-intl';

const ContentBlock = styled(Grid)`
  position: relative;
  ${breakpoint.down('md')`align-content:center;`}
  &:not(:last-child):before {
    z-index: -10;
    position: absolute;
    top: 30%;
    left: 60%;
    content: '';
    width: 75%;
    height: 1px;
    background-color: ${colors.grey};
    ${breakpoint.only('xxs')`display: none`}
  }
`;
const ContentImage = styled(Grid)`
  flex: 1 0 auto;
  align-self: center;
  max-width: 300px;
  padding-bottom: 2rem;
  ${breakpoint.only('xs')`max-width:50px;`}
  ${breakpoint.only('xxs')`max-width:40px;`}
`;
const Styledimg = styled.img`
  position: relative;
  overflow: hidden;
  max-width: 89px;
  margin: 0px auto;
  flex-grow: 1;
  width: 100%;
`;
const StyledTypography = styled(Typography)`
  ${textBold};
  text-align: center;
  text-transform: uppercase;
  font-family: ${props => `${props.theme.typography.fontFamily}`};
  font-size: ${props => `${props.theme.typography.subtitle2.fontSize}px`};
  ${breakpoint.down('md')`font-size: ${props => `${
    props.theme.typography.caption.fontSize
  }
px`};`}
  ${breakpoint.down('sm')`
    display: none`}
`;

const EmotionsBlock = ({ data, image }) => {
  const SvgImage = () => {
    let normalizedProps = image.childImageSharp;
    if (!normalizedProps && image.extension === 'svg') {
      return <Styledimg src={image.publicURL} alt="" />;
    }
  };
  return (
    <ContentBlock container direction="column" item xs={2} sm={2} md={2} lg={2}>
      <ContentImage container alignItems="center" alignContent="center">
        {SvgImage()}
      </ContentImage>
      <StyledTypography>
        <FormattedMessage id={data.label} />
      </StyledTypography>
    </ContentBlock>
  );
};

export default EmotionsBlock;
